import { magicLinkColors, magicLinkRadius } from "./magicLinkTokens";

const text = (size: string, weight: number, color: string) => ({
  fontFamily: "Nunito Sans",
  fontSize: size,
  fontWeight: weight,
  color
});

export const magicLinkFormOverrides = (theme: any) => ({
  mainGrid: {
    width: "100%",
    margin: 0
  },
  maingrid2: {
    width: "100%",
    margin: 0
  },
  maingrid3: {
    width: "100%",
    margin: 0
  },
  buttonRoot: {
    borderRadius: magicLinkRadius.button,
    padding: "8px 12px",
    boxShadow: "none",
    border: `1px solid ${magicLinkColors.border}`,
    fontFamily: "Nunito Sans",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none"
  },
  accordionHeading: text("14px", 600, magicLinkColors.textStrong),
  accordionWhite: {
    boxShadow: "none",
    backgroundColor: magicLinkColors.option
  },
  accordionRound: {
    borderRadius: `${magicLinkRadius.card}px !important`,
    border: `1px solid ${magicLinkColors.border}`
  },
  accordionRoundError: {
    borderRadius: `${magicLinkRadius.card}px !important`,
    border: `1px solid ${theme.palette.error.main}`
  },
  pageHeading: {
    ...text("19px", 600, magicLinkColors.textStrong),
    lineHeight: "26px",
    marginTop: 0
  },
  pageSubHeading: text("14px", 400, magicLinkColors.text),
  question: text("14px", 400, magicLinkColors.text),
  statusHeading: text("14px", 600, magicLinkColors.textStrong),
  fieldLabel: {
    ...text("14px", 600, magicLinkColors.textStrong),
    marginBottom: 4
  },
  fieldPageSubHeading: {
    ...text("14px", 600, magicLinkColors.text),
    marginBottom: 12
  },
  includeText: {
    ...text("12px", 400, magicLinkColors.textMuted),
    marginTop: 0
  },
  dollarSign: text("14px", 600, magicLinkColors.textStrong),
  yesNoText: text("12px", 600, magicLinkColors.textMuted),
  formControl: {
    margin: 0,
    minWidth: 240
  },
  statementRow: {
    ...text("14px", 400, magicLinkColors.text),
    backgroundColor: magicLinkColors.option,
    border: `1px solid ${magicLinkColors.border}`,
    borderRadius: magicLinkRadius.card,
    padding: "12px",
    [theme.breakpoints.down("xs")]: {
      padding: "8px"
    }
  }
});
